import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from '../contents/sequenceDiagram/Layout';
import SEO from '../components/seo';
import { Link } from 'gatsby';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = Layout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <SEO title="Sequence diagram builder" description="Create UML Sequence Diagrams using simple code and integrate it in one click in Jira, Confluence, GitHub, Notion, and more." mdxType="SEO" />
    <h1>{`UML Sequence diagram `}<em parentName="h1">{`Builder`}</em></h1>
    <pre><code parentName="pre" {...{
        "className": "language-sequence",
        "metastring": "copyable autoFocus",
        "copyable": true,
        "autoFocus": true
      }}>{`Alice->Bob: Hello
activate Bob
Bob-->Alice: Hi!
deactivate Bob
`}</code></pre>
    <hr></hr>
    <p>{`Welcome to the free online sequence diagram editor. You can `}<Link to="/sequence-diagram/learn" mdxType="Link">{`learn`}</Link>{` more
about sequence diagrams or read the syntax `}<Link to="/sequence-diagram/documentation" mdxType="Link">{`documentation`}</Link>{`.`}</p>
    <p>{`The online sequence diagram builder let's you create sequence diagrams from simple code and turn it into SVG images.
This tool can be used by coders and non-coders alike and no programming skills are required.`}</p>
    <h2>{`How to add sequence diagrams to Jira or Confluence?`}</h2>
    <p>{`You can integrate your diagrams in Jira, Confluence, Notion, GitHub, and many other tools using the `}<em parentName="p">{`Copy URL`}</em>{` button.
Then in the tool you are using add an image with the generated URL, you are done.`}</p>


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      